import { render, staticRenderFns } from "./peddlrWallet.vue?vue&type=template&id=3dbd4b10"
import script from "./peddlrWallet.vue?vue&type=script&lang=js"
export * from "./peddlrWallet.vue?vue&type=script&lang=js"
import style0 from "./peddlrWallet.vue?vue&type=style&index=0&id=3dbd4b10&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports